import React, { useState } from 'react'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import { usePersonalStore } from '../../../stores/personalInfo'
import { ActivityIndicator, ScrollView, View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import Canvas from '../../canvas'
import CustomButton from '../../shared/button/Button'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import SignatureFormView from '../SignatureFormView'

const OhInformationOnline = ({ navigation, route }) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
        total,
        ids

    } = params


    console.log(ids)
    const [hasDrawn, setHasDrawn] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState('')

    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postohonline } = useFormsStore()




    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey:
                intializeStore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey:
                essUserOnBoardingFormKey,
            completeOnline: true,
            sign: signatureDataURL,
            dependentStatus: values?.isDependent ? values?.isDependent : null,
            singleStatus: values?.isSingle ? values?.isSingle : null,
            noOfDependents: values?.noOfDependents ? values?.noOfDependents : null,
            totalWithholdingExemptions: total,
            additionalWithholding: values?.additionalWithholding ? values?.additionalWithholding : null,
            withholdingWaiver: ids,
            districtOfResidence: values?.districtOfResidence,
            schoolDistrictNumber: values?.schoolDistrictNumber
        }

        const response: any = await postohonline(data)

        if (response?.success === true) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'OH Withholding Taxation '}
                    />
                </View>
            </View>

            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('OhInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />

        </>
    )
}

export default OhInformationOnline
